import { NativeSelect, NativeSelectProps } from '@odekoteam/doppio';

export type PickableMarket = {
  /** The market's position in the form's warehouses list. */
  index: number;
  name: string;
  stocked: boolean;
};

const byName = (a: PickableMarket, b: PickableMarket) =>
  a.name.localeCompare(b.name);

/**
 * "Pick a market to act on" as a select that resets itself after each pick,
 * so it reads as an action ("Add an override…") rather than as a value the
 * page holds. Stocked markets come first: an override or a hide on a market
 * the category does not reach is legal but rarely what anyone means. Each
 * group is then alphabetical, so a market is where its name says it is
 * rather than wherever the warehouses query happened to return it.
 */
export default function MarketPicker({
  label,
  markets,
  onPick,
  disabled,
}: {
  label: string;
  markets: PickableMarket[];
  onPick: (index: number) => void;
  disabled?: boolean;
}) {
  const ordered = [
    ...markets.filter((market) => market.stocked).sort(byName),
    ...markets.filter((market) => !market.stocked).sort(byName),
  ];
  const items: NativeSelectProps['items'] = ordered.map((market) => ({
    value: market.index,
    label: market.stocked ? market.name : `${market.name} (not stocked)`,
  }));

  return (
    <NativeSelect
      value=""
      placeholder={{ label, value: '' }}
      items={items}
      isDisabled={disabled || items.length === 0}
      onValueChange={(value) => {
        if (value !== '') onPick(Number(value));
      }}
    />
  );
}
